// extracted by mini-css-extract-plugin
export default {"root":"AdminLayout_root__IuxaI"};